import { useContext, useEffect, useRef } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

/**
 * #724 Kaydedilmemiş değişiklik koruması (react-router v6 + <BrowserRouter> uyumlu).
 *
 * Proje data-router (createBrowserRouter/RouterProvider) kullanMADIĞI için `useBlocker`
 * çalışmaz. Bunun yerine v6'nın alt seviye navigator'ını (`UNSAFE_NavigationContext`)
 * geçici olarak sararız: `when` true iken bir push/replace navigasyonu (sidebar menü,
 * breadcrumb, İptal, programatik navigate — hepsi) önce window.confirm ile onaylanır.
 * Ayrıca beforeunload ile sekme kapatma / sayfa yenileme de korunur.
 *
 * @param {boolean} when Kaydedilmemiş değişiklik var mı (dirty).
 * @param {string} message Onay metni.
 * @param {object} [bypassRef] { current: boolean } — true iken guard atlanır. Başarılı
 *   kayıttan sonra listeye dönerken uyarı çıkmaması için handleSave bunu true yapar.
 */
export function useUnsavedChangesPrompt(when, message, bypassRef) {
  const navContext = useContext(UNSAFE_NavigationContext);
  const navigator = navContext && navContext.navigator;
  // when/message/bypassRef'i ref üzerinden okuyup effect'i yalnız navigator değişince kur;
  // böylece her dirty değişiminde push/replace tekrar tekrar sarılmaz.
  const cfg = useRef({ when, message, bypassRef });
  cfg.current = { when, message, bypassRef };

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (!cfg.current.when) return;
      e.preventDefault();
      e.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    let restore = null;
    if (navigator && typeof navigator.push === 'function') {
      const originalPush = navigator.push;
      const originalReplace = navigator.replace;
      const guard = (original) => (...args) => {
        const { when: dirty, message: msg, bypassRef: bp } = cfg.current;
        if (!dirty || (bp && bp.current) || window.confirm(msg)) {
          return original.apply(navigator, args);
        }
        return undefined; // navigasyon iptal
      };
      navigator.push = guard(originalPush);
      navigator.replace = guard(originalReplace);
      restore = () => { navigator.push = originalPush; navigator.replace = originalReplace; };
    }

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      if (restore) restore();
    };
  }, [navigator]);
}

export default useUnsavedChangesPrompt;
